import { shopUrlPropertyName } from "@smartrr/shared/constants";
import { Link, LinkProps } from "@tanstack/react-router";
import React from "react";
import { getShopUrlFromGlobals } from "@vendor-app/utils/shopify/getShopUrlFromGlobals";

export const ShopLink = (props: LinkProps) => {
  const shop = getShopUrlFromGlobals();
  return <Link {...props} search={prev => ({ ...prev, [shopUrlPropertyName]: shop })} />;
};
